// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"f6eadae2","213":"bf30cb57","766":"7b099593","970":"fd89475c"}[chunkId] + ".chunk.js";
};